
        <mat-card class="m-2 p-1 h-100" fxLayout="column" >
            <mat-card-header style="min-height: 120px;">
                <mat-card-subtitle class="mb-3 w-100">
                    <form [formGroup]="form" autocomplete="nope">
                        <!-- {{diagnostic}} -->
                        <mat-error *ngIf="error" class="alert alert-danger">{{error}}</mat-error>

                        <div class="w-100">
                            <mat-form-field style="width: 110px" >
                                <input matInput [matDatepicker]="fromDatePicker" formControlName="fromDate">
                                <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #fromDatePicker></mat-datepicker>
                            </mat-form-field>
                            <span style="padding:0 17px;">{{'FIND-TIME.TO' | translate}}</span>
                            <mat-form-field style="width:110px" >
                                <input matInput [matDatepicker]="toDatePicker" formControlName="toDate">
                                <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #toDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="w-100">
                            <mat-form-field style="width:130px;" class="">
                                <mat-select placeholder="{{ 'SCHEDULER.SELECT-THERAPIST' | translate}}" formControlName="scheduler">
                                    <mat-option>{{ 'SCHEDULER.SELECT-THERAPIST' | translate}}</mat-option>
                                    <mat-option *ngFor="let schedulerItem of schedulers" [value]="schedulerItem.ID">
                                        {{ schedulerItem.Name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>    
                            <div class="seperator"></div>
                            <mat-form-field style="width:130px;" class="ml-3">
                                <mat-select placeholder="{{ 'WAITLIST.SELECT-STATUS' | translate}}" formControlName="status">
                                    <mat-option>{{ 'WAITLIST.SELECT-STATUS' | translate}}</mat-option>
                                    <mat-option *ngFor="let status of waitlistStatuses" [value]="status.ID">
                                        {{ status.Name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        
                    </form>
                </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content  class="p-3" style="background-color: #F3F6FB; overflow-y: auto;min-height: 100px;">

                <p *ngIf="waitlistItems.length == 0" fxLayoutAlign="center">{{ 'SCHEDULER.NO-DATA-FOUND' | translate}}</p>

                <div fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="start" class="flex-parent">
                     <app-waitlist-item *ngFor="let item of waitlistItems" 
                     class="mb-3 ml-1 mr-1"
                     fxFlex="auto" 
                     fxFlex.gt-sm="calc(50%-24px)"
                     fxFlex.gt-md="calc(33.3%-24px)" fxLayoutAlign="stretch"  
                      [waitlistItem]="item"
                      (createAppt)="onCreateAppointment($event)"
                      (edit)="onEdit($event)"
                      (delete)="onDelete($event)"></app-waitlist-item>
                </div>

            </mat-card-content>
        </mat-card>

